// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sizeSelect":"o7DO1"};